import { AccountBoxIcon } from './AccountBoxIcon';

/**
 * author: Google
 * id 474D0A31-E56A-4780-9417-DCF8D9A38830
 * name account-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-box.svg
 * tags
 * - Account / User 
 */
export const ContactIcon = AccountBoxIcon;
export default ContactIcon